import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
  declarations: [
    CheckboxComponent,
  ],
  imports: [
    TranslateModule,
  ],
  exports: [
    CheckboxComponent,
  ],
})
export class CheckboxModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/CheckboxComponent/checkbox.module.ts